import type { ComponentProps } from "react"

// Four-point spark used as the prefix on AI suggestions. Fill follows
// currentColor; colour it with a text token (text-primary) at the call site.
export default function AiSuggestion(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={fill}
      aria-hidden
      {...svgProps}
    >
      <path d="M12 3L13.8 10.2L21 12L13.8 13.8L12 21L10.2 13.8L3 12L10.2 10.2Z" />
    </svg>
  )
}
